/** Figma definition: [link](https://www.figma.com/design/2fEScGXkSAxlZaLBCm4ki2/%F0%9F%92%A0-Official-Design-Library?node-id=3232-2521&m=dev). */
export const lineHeight = {
  text: '130%',
  heading: '120%',
} as const;
